import { Button, makeStyles, tokens } from '@fluentui/react-components';
import { EditRegular, VehicleTruckProfileRegular } from '@fluentui/react-icons';
import type { SetupDetails } from '../types/catering';

const useStyles = makeStyles({
  bar: {
    display: 'grid',
    gridTemplateColumns: '1.5rem 1fr 1.5rem',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    border: '0',
    borderRadius: tokens.borderRadiusLarge,
    backgroundColor: tokens.colorPaletteGreenBackground1,
    color: tokens.colorPaletteGreenForeground1,
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalM}`,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
    minWidth: '0',
  },
  icon: {
    color: tokens.colorPaletteGreenForeground1,
    flexShrink: 0,
    width: '1.5rem',
    height: '1.5rem',
  },
  heading: {
    fontWeight: tokens.fontWeightSemibold,
    fontSize: '0.75rem',
    lineHeight: '1rem',
  },
  detail: {
    color: tokens.colorPaletteGreenForeground1,
    fontSize: '0.75rem',
    lineHeight: '1rem',
  },
  edit: {
    color: tokens.colorPaletteGreenForeground1,
    width: '1.5rem',
    minWidth: '1.5rem',
    height: '1.5rem',
    padding: 0,
    '& svg': {
      width: '1.5rem',
      height: '1.5rem',
    },
  },
});

export type DeliverySummaryBannerProps = {
  setup: SetupDetails;
  onEdit: () => void;
};

export function DeliverySummaryBanner({ setup, onEdit }: DeliverySummaryBannerProps) {
  const styles = useStyles();
  return (
    <div className={styles.bar} role="status">
      <VehicleTruckProfileRegular className={styles.icon} aria-hidden="true" />
      <div className={styles.content}>
        <span className={styles.heading}>
          Arrives {setup.window.label} · {setup.room}
        </span>
        <span className={styles.detail}>30 min before start · setup &amp; cleanup included</span>
      </div>
      <Button
        className={styles.edit}
        appearance="subtle"
        size="small"
        aria-label="Edit setup details"
        onClick={onEdit}
      >
        <EditRegular aria-hidden="true" />
      </Button>
    </div>
  );
}
